// This file was generated using `pay js:run gql-v1 --type=fragment --name=PersonRelationshipArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment PersonRelationshipArkFragment on OpenapiPersonRelationship {
    controller
    director
    director
    executive
    officer
    owner
    partner
    percent_ownership
    representative
    title
    legal_guardian
    authorizer
  }
`;

export const personRelationshipArkFragment: PersonRelationshipArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type PersonRelationshipArkFragmentData = {
  readonly __typename: 'OpenapiPersonRelationship';
  readonly controller: boolean | null;
  readonly director: boolean | null;
  readonly executive: boolean | null;
  readonly officer: boolean | null;
  readonly owner: boolean | null;
  readonly partner: boolean | null;
  readonly percent_ownership: number | null;
  readonly representative: boolean | null;
  readonly title: string | null;
  readonly legal_guardian: boolean | null;
  readonly authorizer: boolean | null;
};

export type PersonRelationshipArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const personRelationshipArkFragmentPermissions = {} as const;

doc.permissions = personRelationshipArkFragmentPermissions;

export type PersonRelationshipArkFragmentPermissions = V1PermissionToken<
  typeof personRelationshipArkFragmentPermissions
>;

export type PersonRelationshipArkFragmentDocument = GraphQlDocument<
  PersonRelationshipArkFragmentData,
  PersonRelationshipArkFragmentVariables,
  PersonRelationshipArkFragmentPermissions
>;
